import { ChevronRight, Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RootState, useAppDispatch } from "../../../redux/store";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { getThisWeekTimeCardSummary, getTodayTimeCardSummary } from "../../../redux/features/EmployeeTimeCard";
import { useSelector } from "react-redux";
import { convertDecimalHoursToHM } from "../../../utils/employeeTimeCardhelper";

const TimesheetSummaryTile: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user?.user);
    const [loading, setLoading] = useState<boolean>(false);
    const { todaySummary, thisWeekSummary, groupedTimesheets } = useSelector(
        (state: RootState) => state.employeeTimeCardData
    );

    const isLoading = false; // Simulate loading state if needed

    const handleViewTimesheet = () => {
        dispatch(setTopNavNameTitle("My Timesheet"));
        navigate("/m-timesheet", { state: { from: "/mobile-dashboard" } });
    };
    console.log("Fetching timecard data for user:", user);

    useEffect(() => {
        if (user?.os_emp_account_id) {
            setLoading(true);
            const id = Number(user?.os_emp_account_id);
            Promise.all([
                dispatch(getTodayTimeCardSummary(id)),
                dispatch(getThisWeekTimeCardSummary(id)),
            ])
                .then(() => {
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Error fetching timecard data", error);
                    setLoading(false);
                });
        }
    }, [dispatch, user?.os_emp_account_id]);
    return (
        <div className="p-6 rounded-lg border border-gray-300 bg-white mb-4">
            <div className="flex items-center justify-between">
                <h2
                    className="text-xl font-semibold text-blue-500 leading-none flex items-center"
                    onClick={handleViewTimesheet}
                >
                    My Timesheet
                </h2>
                <ChevronRight className="w-7 h-7 flex-shrink-0 text-blue-500" onClick={handleViewTimesheet} />
            </div>

            {isLoading ? (
                <div className="flex justify-center items-center h-24">
                    <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                </div>
            ) : (
                <div className="mt-4 grid text-start">
                    {/* <div>
            <p className="text-sm text-gray-500 mb-1">Today</p>
            <p className="text-lg font-bold text-gray-700">  {convertDecimalHoursToHM(todaySummary?.total_hours ?? 0)}</p>
          </div> */}

                    {loading ? (
                        <div className="flex justify-center py-4">
                            <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                        </div>
                    ) : (
                        <>
                            <div>
                                <p className="text-sm text-gray-500 mb-1">This Pay Period</p>
                                <p className="text-lg font-bold text-gray-700">
                                    {" "}
                                    {convertDecimalHoursToHM(thisWeekSummary?.total_hours ?? 0)}
                                </p>
                            </div>
                        </>
                    )}

                    {/* <div>
            <p className="text-sm text-gray-500 mb-1">This Period</p>
            <p className="text-lg font-bold text-gray-700">{thisPeriod}</p>
          </div> */}
                </div>
            )}
        </div>
    );
};

export default TimesheetSummaryTile;
